import { useDispatch, useSelector } from 'react-redux';
import './CommentForm.css';
import { changeCommentErrorMessage, changeCommentText, createCommentAndLoadComments, selectCommentErrorMessage, selectCommentText } from './commentFormSlice';
import { selectSupportTicketId } from '../supportTicketForm/supportTicketFormSlice';
import { selectUser } from '../home/userSlice';
import { selectToken } from '../login/loginSlice';

export default function CommentForm() {
    const dispatch = useDispatch();

    const commentText = useSelector(selectCommentText);
    const commentErrorMessage = useSelector(selectCommentErrorMessage);
    const supportTicketId = useSelector(selectSupportTicketId);
    const userInfo = useSelector(selectUser);
    const username = userInfo.username;
    const token = useSelector(selectToken);

    const handleNewCommentChange = (event) => {
        if (commentErrorMessage) {
            dispatch(changeCommentErrorMessage(""));
        }
        dispatch(changeCommentText(event.target.value));
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (commentText) {
            const newComment = {
                supportTicketId,
                createdBy: username,
                commentText
            }
            dispatch(createCommentAndLoadComments({newComment, token}))
        } else {
            dispatch(changeCommentErrorMessage("Comment text cannot be blank."))
        }
        
    }

    return (
        <form>
            <div className="comment-header">
                <label htmlFor='comment-text'>
                    <p>Add new Comment:</p>
                    <textarea rows='3' cols='45' onChange={handleNewCommentChange} value={commentText}></textarea>
                </label>
                <button className='add-comment-button' onClick={handleSubmit}>Submit</button>
            </div>
            <p className='error'>{commentErrorMessage}</p>
        </form>
    )
}